import { Component, Input } from '@angular/core';
import { CanDisable, mixinDisabled } from '@angular/material/core';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { Download } from 'cloud-shared-lib';
import { Observable, catchError, finalize, throwError } from 'rxjs';

export class DownloadButtonBase {}

// eslint-disable-next-line no-underscore-dangle
export const _DownloadButtonMixinBase = mixinDisabled(DownloadButtonBase);

@Component({
  selector: 'csl-download-button',
  templateUrl: './download-button.component.html',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['disabled'],
})
export class DownloadButtonComponent extends _DownloadButtonMixinBase implements CanDisable {
  @Input() icon = 'download';
  @Input() downloadFn: () => Observable<Download>;
  @Input() buttonTooltipText = '';
  @Input() loaderTooltipText = '';
  @Input() errorMessage = '';

  download$: Observable<Download>;

  constructor(private snackBar: MatSnackBar) {
    super();
  }

  download(): void {
    this.download$ = this.downloadFn().pipe(
      catchError(err => {
        this.snackBar.open($localize`${this.errorMessage}` || $localize`Ошибка скачивания`);
        return throwError(() => err);
      }),
      finalize(() => (this.download$ = null))
    );
  }
}
